import { useState } from "react";
import { Close, MoreVert } from "@mui/icons-material";
import { Hidden, IconButton, styled } from "@mui/material";

// STYLED COMPONENTS
const ToolbarMenu = styled("div")(({ theme }) => ({
  "&.open $menuContainer": {
    [theme.breakpoints.down("sm")]: { display: "flex" }
  }
}));

const MenuContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    display: "none",
    padding: "4px 8px",
    position: "absolute",
    backgroundColor: theme.palette.primary.dark
  }
}));

export default function MatxToolbarMenu({ offsetTop, children }) {
  const [open, setOpen] = useState(false);
  const handleToggle = () => setOpen(!open);

  return (
    <ToolbarMenu className={open}>
      <Hidden mdUp>
        <IconButton onClick={handleToggle}>{open ? <Close /> : <MoreVert />}</IconButton>
      </Hidden>

      <MenuContainer sx={{ top: offsetTop, left: 0 }}>{children}</MenuContainer>
    </ToolbarMenu>
  );
}
